import { render, staticRenderFns } from "./notification-action.vue?vue&type=template&id=33a9915a"
import script from "./notification-action.vue?vue&type=script&lang=js"
export * from "./notification-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports